import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ChatConversation } from '../../../domain/models/chat-conversation.model';
import { ConversationSummary } from '../../../domain/models/conversation-summary.model';
import { QuickQuestion } from '../../../domain/models/quick-question.model';
import { UserProfile } from '../../../domain/models/user-profile.model';

@Component({
  selector: 'talk-to-your-data-chatbot-shell',
  templateUrl: './chatbot-shell.component.html',
  styleUrls: ['./chatbot-shell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatbotShellComponent {
  @Input() quickQuestions: readonly QuickQuestion[] | null = [];
  @Input() activeConversation: ChatConversation | null = null;
  @Input() conversationHistory: readonly ConversationSummary[] | null = [];
  @Input() savedConversations: readonly ConversationSummary[] | null = [];
  @Input() selectedConversationId: string | null = null;
  @Input() sendingMessage: boolean | null = false;
  @Input() loading: boolean | null = false;
  @Input() error: string | null = null;
  @Input() userProfile: UserProfile | null = null;
  @Input() focusInputTrigger = 0;
  @Output() conversationSelected = new EventEmitter<string>();
  @Output() readonly conversationSaved = new EventEmitter<string>();
  @Output() readonly conversationUnsaved = new EventEmitter<string>();
  @Output() readonly conversationRenamed = new EventEmitter<{ conversationId: string; title: string }>();
  @Output() readonly conversationDeleted = new EventEmitter<string>();
  @Output() readonly suggestionSelected = new EventEmitter<QuickQuestion>();
  @Output() readonly messageSubmitted = new EventEmitter<string>();
  @Output() readonly newChatClicked = new EventEmitter<void>();
  @Output() readonly stopRequested = new EventEmitter<void>();

  sidebarVisible = false;

  // A restored conversation (selectedConversationId set) must render the panel even with 0 messages.
  get isWelcomeState(): boolean {
    if (this.selectedConversationId) {
      return false;
    }

    if (!this.activeConversation) {
      return true;
    }

    return (this.activeConversation.messages || []).length === 0;
  }

  toggleSidebar(): void {
    this.sidebarVisible = !this.sidebarVisible;
  }

  onConversationSelected(conversationId: string): void {
    this.conversationSelected.emit(conversationId);
  }

  onSuggestionSelected(question: QuickQuestion): void {
    this.suggestionSelected.emit(question);
  }

  onMessageSubmitted(message: string): void {
    this.messageSubmitted.emit(message);
  }

  onStopRequested(): void {
    this.stopRequested.emit();
  }

  onNewChat(): void {
    this.newChatClicked.emit();
  }
}
